import styled from 'styled-components';
import { BasicSectionContainer } from 'screens/style';
import { colors } from 'constants/colors';
// import signIn from  'assets/images/signIn.png';
import { styleSizes } from "constants/styleSizes";

export const SignInSectionContainer = styled(BasicSectionContainer)`
  width: 100%;
  min-height: 667px;
  display: flex;
  justify-content: center;
  align-content: center;
  


  .innerContainer {
    margin-top: 65px;
    display: flex;
    justify-content: space-between;
    align-content: center;
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      justify-content: center;
    }
    .signInImageBox {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        display: none;
      }
      .signInImage {
        width: 613px;
        height: auto;
      }
    }
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      margin-top: 32px;
    }
    .signInButton {
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        align-self: flex-end;
        font-size: 16px;
        width: 96px;
        height: 48px;
      }
    }
  }

  .emailPhone {
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      margin-top: 24px;
    }
  }

  .butLinks {
    display: none;
    @media (max-width: calc(${styleSizes.tabletBreakpoint} + 1px)) {
      display: block;
    }
    margin-top: 24px;
    font-size: 16px;
    color: ${colors.signInBorderColor};
    a {
      color: ${colors.hoverBlue};
      text-decoration: underline;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const SignInFormContainer = styled.div`
  width: 100%;
  max-width: 340px;
  background-color: transparent;
  margin: 0;
  z-index: 100;

  .formTitle {
    font-size: 48px;
    font-weight: 700;
    color: ${colors.almostBlack};
    margin-bottom: 32px;
    text-align: center;
  }

  .inputFieldContainer {
    width: 100%;
  }

  .buttonContainer {
    margin-top: 32px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 16px;
  }

  .tips {
    font-size: 16px;
    color: ${colors.hoverBlue};
    text-decoration: underline;
    margin-bottom: 16px;
    cursor: pointer;
  }
  .forgotPassTop {
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      display: none;
    }
  }
  .dontHaveAcc {
    margin-top: 32px;
    width: 100%;
    text-align: center;
    .tips {
      font-weight: 600;
    }
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      display: none;
    }
  }
  .dontHaveAccMobile {
    display: none;
    margin-top: 32px;
    width: 100%;
    text-align: center;
    .tips {
      font-weight: 600;
    }
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      display: block;
    }
  }

  .dividerContainer {
    width: 100%;
    display: flex;
    margin: 32px 0 16px 0;
    color: ${colors.almostBlack};
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      display: none;
    }
    span {
      margin: 0 10px;
    }

    .divider {
      width: 100%;
      padding: 0 15px;
      align-items: center;
      margin: auto;
      box-sizing: border-box;
      border: 0;
      border-top: 1px solid ${colors.signInBorderColor};
    }
  }
`;
